var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-app-bar',{staticClass:"d-flex justify-center",attrs:{"app":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('h3',[_vm._v("AMAZON KEYWORDS ANALYZER")])])]),_c('v-main',[_c('MainComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }